import { Injectable } from '@angular/core';
import { CupService } from '../shared/services/cup.service';


@Injectable()
export class FieldValidateService {

    constructor(private cupService: CupService,  ) { }


    validateEmail( email: string ) {
        if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test( email ) ) {
            return ( true );
        }
        return false;
    }
    validatePhone( phone: string ) {
        let newVal = '';
        for ( let i = 0; i < phone.length; i++ ) {
            const s: string = phone.charAt( i );
            if ( !isNaN( Number( s ) ) && s !== ' ' ) {
                newVal += s;
            }
        }

        const phoneno = /^\d{10}$/;
        if ( newVal.length === 10 ) {
            return true;
        }
        return false;
    }
    validateZip( zip: string ) {
        const zipPattern = /^\d{5}$/;
        if ( zip.match( zipPattern ) ) {
            return true;
        }
        return false;
    }

    validateUserName( userName: string ) {
        const userNamePattern = /^[a-zA-Z][a-zA-Z0-9]{4,}$/;
        if ( userName.match( userNamePattern ) ) {
            return true;
        }
        return false;
    }

    validateNumeric( value: string, length: number ) {
        const numberPattern = '^\\d{' + length + '}$';
        const regEx = new RegExp(numberPattern);
        if ( value.match( regEx ) ) {
            return true;
        }
        return false;
    }

    
    validateCred(newPassword: string, userNamePattern?: string) {
        let isValid = true;    
       
        if (newPassword.length < 8) {
            //this.errorMessage = 'Password must be at least 8 characters long.';
            isValid = false;
          } else if (!/[a-z]/.test(newPassword) || !/[A-Z]/.test(newPassword)) {
            //this.errorMessage = 'Password must contain both upper and lower case characters.';
            isValid = false;
          } else if (!/[0-9$!@*?|]/.test(newPassword)) {
            //this.errorMessage = 'Password must contain at least one number or special character ($!@*?|).';
            isValid = false;
          } else if (/[^0-9a-zA-Z$!@*?|]/.test(newPassword)) {
            //this.errorMessage = 'Password contains invalid characters.';
            isValid = false;
          } else if (/ {2,}/.test(newPassword)) {
            //this.errorMessage = 'Password cannot contain blank spaces.';
            isValid = false;
          }  else if (/([a-zA-Z0-9$!@*?|])\1\1/.test(newPassword)) {
            //this.errorMessage = 'Password cannot contain a character or number more than twice in a row.';
            isValid = false;
          }
          else if(userNamePattern) {
            const userName = userNamePattern || this.cupService.getUserNameFromJWT();

            // Generate all possible sequences of three or more consecutive characters from the username
            for (let i = 0; i < userName.length - 2; i++) {
                const sequence = userName.substring(i, i + 3);
                const regex = new RegExp(sequence, 'i');
                if (regex.test(newPassword)) {
                    //this.errorMessage = 'Password cannot contain three or more consecutive characters of the username.';
                    isValid = false;
                    break
                }
            }
          }
        return isValid;
    }
    validateSameNumber(value) {
        for (let i = 1; i < value.length; i++) {
          if (value[0] != value[i]) {
            return false;
          }
        }
        return true;
      }

}